import React from 'react';

import NetBankingOption from '../../Common/CommonOption/CommonOption'; 

import hdfcImage from '../../../../assets/images/payments/banking/hdfc.svg';
import iciciImage from '../../../../assets/images/payments/banking/icici.svg';
import sbiImage from '../../../../assets/images/payments/banking/sbi.svg';
import citiImage from '../../../../assets/images/payments/banking/citi.svg';
import axisImage from '../../../../assets/images/payments/banking/axis.svg';
import pnbImage from '../../../../assets/images/payments/banking/pnb.svg';
import idbiImage from '../../../../assets/images/payments/banking/idbi.svg';
import kotakImage from '../../../../assets/images/payments/banking/kotak.svg';

const netBankingOptions = (props) =>  {

    let banks = props.banks.map((bank, index) => {
        let image = null;
        if (bank.logoURL.includes('sbi')) {
            image = sbiImage;
        } else if (bank.logoURL.includes('icici')) {
            image = iciciImage;
        } else if (bank.logoURL.includes('citi')) {
            image = citiImage;
        } else if (bank.logoURL.includes('axis')) {
            image = axisImage;
        } else if (bank.logoURL.includes('pnb')) {
            image = pnbImage;
        } else if (bank.logoURL.includes('idbi')) {
            image = idbiImage;
        } else if (bank.logoURL.includes('kotak')) {
            image = kotakImage;
        } else if (bank.logoURL.includes('hdfc')) {
            image = hdfcImage;
        }
        return <NetBankingOption key={index} name={bank.displayText} code={bank.code} change={props.change}><img src={image} alt="Freecharge" /></NetBankingOption>;
    })

    return (
        <div className={`u-flex f-wrap phone-justify-content-between`}>
            {banks}
        </div>
    );
}

export default netBankingOptions;


// WEBPACK FOOTER //
// ./src/components/Payment/NetBanking/NetBankingOptions/NetBankingOptions.js